import PostalKit from '../../ports-frontend/PostalKit';
import Cookie from '../../ports-frontend/Cookie';
import Location from '../../ports-frontend/Location';
import { updateLoginStatus } from '../tracking';

import { SessionWatcherCallback } from '../../logic/main/services/watchSession';
import { UNITY_TOPICS } from '../constants';

import { createLogger } from '../utils/logger';
const logger = createLogger('session.unity');

async function setToken(token: string) {
  const { hostname } = await Location.get();
  const splitedHostName = hostname.split('.');
  const domain = `.${splitedHostName
    .splice(splitedHostName.length - 2)
    .join('.')}`;

  await Cookie.set('unity-external-token', token, {
    domain: domain.includes('.williamhill') ? domain : '.williamhill.com',
  });
}

export async function getUserData() {
  return new Promise<{
    accountId: string;
    currency: string;
    currencyDivisor: number;
    balance: number;
    playableBalance: number;
    language: string;
    token: string;
  }>(async resolve => {
    await PostalKit.onSubscribe(
      async (data: {
        event: string;
        payload: {
          token: string;
          accountId: string;
          currency: string;
          currencyDivisor: number;
          balance: number;
          playableBalance: number;
          language: string;
        };
      }) => {
        if (data.event !== UNITY_TOPICS.UPDATE_USER_STATE) {
          return;
        }
        resolve({ ...data.payload });
      },
      ['events', 'pam']
    );
    await PostalKit.publishEvent({
      channel: 'pam',
      topic: 'events',
      data: { event: 'pam.command.session.get-state' },
    });
  });
}

export async function sessionWatcher({
  callback,
}: {
  callback: SessionWatcherCallback;
}) {
  const unsubscribe = await PostalKit.onSubscribe(
    async (data: { event: string; payload: { token: string; user: any } }) => {
      const { event } = data;
      logger.log(data);
      switch (event) {
        case UNITY_TOPICS.LOGIN: {
          logger.log('logged in!');
          const user = await getUserData();
          await setToken(user.token);
          callback({
            type: 'SESSION_STATE_LOGGED_IN',
            data: {
              loggedIn: true,
              userStatus: 'customer',
              userAccountNumber: user.accountId,
              authToken: {
                access_token: user.token,
              },
              userToken: '', // search-insights
              currency: user.currency,
              userCurrency: user.currency,
              currencyDivisor: user.currencyDivisor,
              balance: user.balance,
              playableBalance: user.playableBalance,
              language: user.language,
            },
          });
          callback({ type: 'GAMING_USER_DETAILS_FETCHED' }); // required for tracking
          break;
        }
        case UNITY_TOPICS.LOGOUT: {
          logger.log('logged out!');
          await setToken('');
          updateLoginStatus(false);
          callback({
            type: 'SESSION_STATE_LOGGED_OUT',
            data: {
              loggedIn: false,
              userStatus: 'non-customer',
              userAccountNumber: '',
              authToken: {
                access_token: '',
              },
              userToken: '', // search-insights
              currency: '',
              userCurrency: '',
              currencyDivisor: 0,
              balance: 0,
              playableBalance: 0,
              language: '',
            },
          });
          break;
        }
      }
    },
    ['events', 'pam']
  );

  return () => {
    unsubscribe();
  };
}
